import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import _ from "lodash";
import moment from "moment-timezone";
import styled from "styled-components";
import axios from "axios";

import LabsApi from "../../api/labs-api";
import { DormitorySearchPreview } from "./search-results-page";

import { Breadcrumb, Button, Container, Frame, Row, RowWrapper, TExtra } from "components/ui-kit/styled-templates";

import DormitoriesApi from "api/dormitories-api";
import EventsApi from "api/events-api";
// import LabsApi from "api/labs-api";
import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import { resolveFileUrl } from "constants/config";
import { useStorageListener } from "hooks/useStorage";

import { ERoles } from "types/enums";

const UniversityPublicPage = () => {
    const { t } = useTranslation();

    const { universityId } = useParams();
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);
    useBodyBackground(`white`);

    const { details: university = {} } = useStorageListener(`universities.${universityId}`, {});
    const now = Date.now();
    const events = useStorageListener((state) =>
        _.values(state?.events)
            ?.filter?.((i) => (
                i?.universityId === universityId &&
                i?.hiddenFromAll != true &&
                i?.hideFromAll != true &&
                i?.onModeration !== true &&
                (i?.details?.dates?.to || i?.details?.dates?.from) >= now
            ))
            ?.sort?.((a, b) => {
                const endA = a?.details?.dates?.to || a?.details?.dates?.from || 0;
                const endB = b?.details?.dates?.to || b?.details?.dates?.from || 0;
                return endB - endA; // Чем позже заканчивается — тем выше
            })
    );
    const dormitories = useStorageListener((state) => _.values(state?.dormitories)?.filter?.((i) => (i?.universityId === universityId && i?.hiddenFromAll != true  && i?.hideFromAll != true)));
    const rooms = useStorageListener((state) => _.values(state?.rooms)?.filter?.((i) => (i?.universityId === universityId  && i?.hiddenFromAll != true  && i?.hideFromAll != true)));
    const labs = useStorageListener((state) => _.values(state?.labs)?.filter?.((i) => (i?.universityId === universityId  && i?.hiddenFromAll != true  && i?.hideFromAll != true)));

    const [ambassadors, setAmbassadors] = useState<any[]>([]);

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
    }, []);
    useEffect(() => {
        EventsApi.getEvents();
    }, []);
    useEffect(() => {
        DormitoriesApi.getAllDormitories();
    }, []);
    useEffect(() => {
        LabsApi.getLabs();
    }, []);

    useEffect(() => {
        axios.get("/ambassadors/all").then((response) => {
            const allAmbassadors = response.data;
            const universityAmbassadors = allAmbassadors.filter(
                (amb: any) => amb.ambassadorUniversityId === universityId
            );
            setAmbassadors(universityAmbassadors);
        }).catch((err) => {
            console.error('Error loading ambassadors:', err);
        });
    }, [universityId]);

    console.log('events = ', events);

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);

    // useEffect(LabsApi.getLabs, []);
    // // @ts-ignore
    // useEffect(RoomsApi.getDormitoryRooms, []);
    return (
        <>
            <Container>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("qpt3v1t4wts")}</Breadcrumb.Item>
                    <Breadcrumb.Item to="/universities">{t("n5usjb0furl")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
            </Container>
            <Row extra={`width: inherit; background: #F4F4F4;`}>
                <Container extra={`align-items: flex-start;`}>
                    <HeaderRowWrapper university={university}>
                        <h1>{_.get(university, `name`, `Название отсутствует`)}</h1>
                        <Row extra={`gap: 16px;`}>
                            {/* <Link to={role === ERoles.Guest ? `/login` : `/create-event-booking/${universityId}`}>
                                <Button>Оставить заявку</Button>
                            </Link> */}
                            {/* <Button variant="outlined">Написать отзыв</Button> */}
                        </Row>
                    </HeaderRowWrapper>
                </Container>
            </Row>
            <Container extra={`align-items: flex-start; margin: 25px 0 50px 0;`}>
                {role === ERoles.Admin && (
                    <Link to={`/university/${universityId}/edit`}>
                        <Button extra="margin: 25px 0;">{t("cyb02dy42tc")}</Button>
                    </Link>
                )}
                <RowWrapper extra={`gap: 16px; @media (max-width: 991px) { flex-direction: column; };`}>
                    <MainPhoto src={resolveFileUrl(_.get(university, `photo`))} />
                    <InfoBlock>
                        <div>
                            <div>{t("r207aqdwh19")}</div>
                            <strong>{_.get(university, `committee`)}</strong>
                        </div>
                        <div>
                            <div>{t("6kg5oj1lqzt")}</div>
                            <strong>{_.get(university, `region`)}</strong>
                            {/* <a>http://www.ryazangov.ru/</a> */}
                        </div>
                        <div>
                            <div>{t("r207aqdwh18")}</div>
                            <strong>{_.get(university, `city`)}</strong>
                        </div>
                        <div>
                            <div>{t("8f41tjurjnk")}</div>
                            <strong>{_.get(university, `shortName`)}</strong>
                            <a href={_.get(university, `site`)}>{_.get(university, `site`)}</a>
                        </div>
                        {/* <div>
                            <div>Адрес</div>
                            <strong>390027, Рязанская область, г. Рязань, Касимовское шоссе, д.25</strong>
                        </div> */}
                    </InfoBlock>
                </RowWrapper>

                {ambassadors.length > 0 && (
                    <AmbassadorsSection>
                        <h3>Контактные данные Амбассадора в принимающей образовательной организации</h3>
                        <AmbassadorsGrid>
                            {ambassadors.map((ambassador) => (
                                <AmbassadorCard
                                    key={ambassador.id}
                                    onClick={() => window.open(`/ambassadors/${ambassador.id}`, "_blank")}
                                >
                                    <AmbassadorAvatar src={resolveFileUrl(ambassador.photo || ambassador.avatar)} />
                                    <AmbassadorName>
                                        {ambassador.name || `${ambassador.firstName || ''} ${ambassador.lastName || ''}`.trim()}
                                    </AmbassadorName>
                                </AmbassadorCard>
                            ))}
                        </AmbassadorsGrid>
                    </AmbassadorsSection>
                )}

                {/* <h3>Заголовок общей информации</h3>
                <div>
                    "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                    quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas
                    sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro
                    quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt
                    ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis
                    suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit
                    esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"
                </div> */}

                {university?.video && (
                    <>
                        <div style={{marginTop: 10, marginBottom: 10}} >
                            <h3>{t("gj7fwspuj2")}</h3>
                            <Video src={university?.video} controls extra="margin-top: 15px;" />
                        </div>
                    </>
                )}

                {events.length > 0 && (
                    <>
                        <h2>{t("cv8b24q6eka")}</h2>
                        <Row className={'x2-row'} extra={`width: 100%; justify-content: flex-start; gap: 15px; flex-wrap: wrap; > * { width: calc((100% - 15px) / 2); };`}>
                            {events?.map?.(({ id: eventId, details: event = {} }, index) => (
                                <Link to={`/events/${eventId}`} key={index}>
                                    <EventTab.Component event={event} />
                                </Link>
                            ))}
                        </Row>
                    </>
                )}
                {dormitories.length > 0 && (
                    <>
                        <h2>{t("nyfna84sobo")}</h2>
                        <Row className={'x2-row'} extra={`width: 100%; justify-content: flex-start; gap: 15px; flex-wrap: wrap; > * { width: calc((100% - 15px) / 2); };`}>
                            {dormitories?.map?.(({ id: dormitoryId, details: dormitory = {} }, index) => (
                                <Link className={"var_uni_link"} to={`/dormitory/${dormitoryId}`} key={index}>
                                    <DormitorySearchPreview.Component
                                        {...dormitory}
                                        rooms={_.values(rooms)?.filter?.((i) => i?.dormitoryId === dormitoryId)}
                                        university={university}
                                    />
                                </Link>
                            ))}
                        </Row>
                    </>
                )}

                {labs.length > 0 && (
                    <>
                        <h2>{t("sa9sojlvtqe")}</h2>
                        <Row className={'x2-row'} extra={`width: 100%; justify-content: flex-start; gap: 15px; flex-wrap: wrap; > * { width: calc((100% - 15px) / 2); };`}>
                            {labs?.map?.(({ id: labId, details: lab = {} }, index) => (
                                <Link className={"var_uni_link"} to={`/lab/${labId}`} key={index}>
                                    <LabTab.Component lab={lab} university={university} />
                                </Link>
                            ))}
                        </Row>
                    </>
                )}
            </Container>
        </>
    );
};

const EventTab = {
    Component: (props) => {
        const { t } = useTranslation();

        const { event } = props;
        return (
            <EventTab.Wrapper>
                <h3>{_.get(event, `name`, `-`)}</h3>
                <div className="link">{_.get(event, `type`)}</div>
                <Row>
                    <div>
                        <div>{t("f5jjn4klqsl")}</div>
                        <strong>
                            {t("0puzxl9rfwqr")} {_.get(event, `price`, 0)} ₽
                        </strong>
                    </div>
                    <div>
                        <div>{t("5ql98f4rvzo")}</div>
                        <strong>
                            {moment(_.get(event, `dates.from`)).format(`DD.MM.YYYY`)} - {moment(_.get(event, `dates.to`)).format(`DD.MM.YYYY`)}
                        </strong>
                    </div>
                </Row>
                <div>
                    {(_.get(event, `description`) || "").slice(0, 100)}
                    {(_.get(event, `description`) || "").length > 100 ? `...` : ``}
                </div>
                <strong>
                    <div className="link">{t("505vredl5br")}</div>
                </strong>
            </EventTab.Wrapper>
        );
    },
    Wrapper: styled(Frame)`
        width: 100%;
        /* flex: 0.5; */
        padding: 24px 20px;
        box-sizing: border-box;
        border-radius: 8px;
        border: 1px solid ${({ theme }) => theme.halfblue};

        align-items: flex-start;
        gap: 8px;

        * {
            display: flex;
        }

        ${Row} {
            width: 100%;

            > * {
                flex-direction: column;
                width: 100%;
                flex: 1;
                gap: 8px;
            }
        }

        .link {
            color: ${({ theme }) => theme.blue};
        }
    `,
};

const Video = styled.video<{ extra?: TExtra }>`
    width: 100%;

    ${({ extra }) => extra}
`;


const LabTab = {
    Component: (props) => {
        const { t } = useTranslation();

        const { lab } = props;
        return (
            <EventTab.Wrapper>
                <h3>{_.get(lab, `name`, `-`)}</h3>
                <div className="link">{_.get(lab, `type`)}</div>
                <Row>
                    {_.get(lab, "shortDescription") && (
                        <div>
                            <div>{t("2pur1zd4w2d")}</div>
                            <strong>{_.get(lab, `shortDescription`)}</strong>
                        </div>
                    )}

                    {/*<div>*/}
                    {/*    <div>Даты проведения:</div>*/}
                    {/*    <strong>*/}
                    {/*        {moment(_.get(lab, `dates.from`)).format(`DD.MM.YYYY`)} - {moment(_.get(lab, `dates.to`)).format(`DD.MM.YYYY`)}*/}
                    {/*    </strong>*/}
                    {/*</div>*/}
                </Row>
                <div>
                    {(_.get(props, `description`) || "").slice(0, 100)}
                    {(_.get(props, `description`) || "").length > 100 ? `...` : ``}
                </div>
                <strong>
                    <div className="link">{t("mnlip2gtop8")}</div>
                </strong>
            </EventTab.Wrapper>
        );
    },
    Wrapper: styled(Frame)`
        width: 100%;
        /* flex: 0.5; */
        padding: 24px 20px;
        box-sizing: border-box;
        border-radius: 8px;
        border: 1px solid ${({ theme }) => theme.halfblue};

        align-items: flex-start;
        gap: 8px;

        * {
            display: flex;
        }

        ${Row} {
            width: 100%;

            > * {
                flex-direction: column;
                width: 100%;
                flex: 1;
                gap: 8px;
            }
        }

        .link {
            color: ${({ theme }) => theme.blue};
        }
    `,
};

const InfoBlock = styled(Frame)`
    width: 100%;
    height: 380px;
    flex: 1;
    border-radius: 12px;
    background: ${({ theme }) => theme.lightblue};
    padding: 32px;
    box-sizing: border-box;

    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;

    * {
        display: flex;
        flex-direction: column;
    }

    > * {
        width: 50%;
        gap: 8px;

        strong {
            min-height: 50px;
        }

        a {
            color: ${({ theme }) => theme.blue};
        }
    }
`;

const MainPhoto = styled(Frame)<{ src?: string }>`
    width: 100%;
    height: 380px;
    flex: 1;
    border-radius: 12px;
    background: url("${({ src }) => src}") no-repeat center center / contain;
`;

const HeaderRowWrapper = styled(RowWrapper)<{ university: Object }>`
    ${({ theme, university }) => _.isEmpty(_.get(university, `name`)) && `color: ${theme.red};`}
    h1 {
        flex: 1;
    }

    @media (max-width: 991px) {
        flex-direction: column;

        h1 {
            margin: 20px 0;
            line-height: 56px;
        }

        div {
            margin: 0 0 32px 0;
        }
    }
`;

const AmbassadorsSection = styled.div`
    width: 100%;
    margin-top: 40px;
    margin-bottom: 40px;

    h3 {
        margin-bottom: 20px;
    }
`;

const AmbassadorsGrid = styled.div`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
`;

const AmbassadorCard = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: #f5f5f5;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background: #e8e8e8;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
`;

const AmbassadorAvatar = styled.div<{ src?: string }>`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-image: url("${({ src }) => src}");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #ddd;
    flex-shrink: 0;
`;

const AmbassadorName = styled.div`
    font-weight: 600;
    font-size: 16px;
    color: #02bf89;

    &:hover {
        text-decoration: underline;
    }
`;

export default UniversityPublicPage;
